/* Révélation au toucher de l'achat rapide, partagée par toutes les grilles de
   tuiles — page de maison, page catalogue, et toute grille future.

   Extrait de `pp-maison.liquid`, où il était écrit en dur sur `.pp-mai__grid`.
   La page catalogue avait besoin du même comportement : le dupliquer aurait
   créé deux copies à corriger au lieu d'une. La grille se déclare désormais
   par `data-pp-quickadd`, et le script les prend toutes.

   Ne s'exécute QUE sur pointeur grossier : sur bureau, le survol CSS fait déjà
   le travail et ce script n'a rien à faire.

   Règle : toucher l'IMAGE révèle le bandeau et n'ouvre pas la fiche ; toucher
   le nom ou le prix ouvre la fiche comme un lien ordinaire. Sans cette
   répartition, le premier toucher confisquerait l'accès au produit. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) return;

  var grilles = document.querySelectorAll('[data-pp-quickadd]');
  if (!grilles.length) return;

  /* La fermeture porte sur TOUTES les grilles de la page, pas seulement celle
     qu'on touche : deux bandeaux ouverts en même temps sur deux grilles
     différentes seraient un état que rien ne referme. */
  function fermerTout(sauf) {
    document.querySelectorAll('[data-pp-quickadd] .pp-cpt__product[data-revele]').forEach(function (t) {
      if (t !== sauf) t.removeAttribute('data-revele');
    });
  }

  grilles.forEach(function (grille) {
    grille.addEventListener('click', function (e) {
      var tuile = e.target.closest('.pp-cpt__product');
      if (!tuile) return;
      if (e.target.closest('.pp-cpt__buy')) return;      /* les commandes agissent normalement */
      var surImage = e.target.closest('.pp-cpt__product-img');
      if (!surImage) { fermerTout(null); return; }       /* nom, notes, prix : c'est un lien */
      if (!tuile.querySelector('.pp-cpt__buy')) return;  /* produit épuisé : pas de bandeau */
      if (tuile.hasAttribute('data-revele')) return;     /* déjà ouvert : le lien reprend la main */
      e.preventDefault();
      fermerTout(tuile);
      tuile.setAttribute('data-revele', '');
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-pp-quickadd]')) fermerTout(null);
  });
})();
